<template>
  <div class="c-spinner-component">
    <!-- Loading ... -->
    <div v-if="!loaded() && !failed()" class="c-spinner-wrapper">
      <div
        :class="{ 'c-spinner': failed }"
        role="alert"
        aria-live="polite"
      >
      </div>
    </div>
    <!-- Failed! -->
    <p v-if="failed()" :class="{ 'is-visuallyHidden': (!failed && loaded()) }">
      {{ loadingText() }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import loadStatus from '../utilities/loadStatus'

export default {
  name: 'LoadIndicator',
  props: {
    request: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['loadingState', 'content'])
  },
  methods: {
    loaded() {
      return this.loadingState[this.request] === loadStatus.complete
    },
    failed() {
      return this.loadingState[this.request] === loadStatus.fail
    },
    loadingText() {
      return this.failed()
        ? this.content.loading_request_failed_text
        : this.content.loading_request_active_text
    }
  }
}
</script>
